import { useGetQuoteRates } from '@/modules/spot-quote';
import { QuoteRateResults } from '@/modules/spot-quote/components/quote-get-rate/quote-rate-results/quote-rate-results';
import { useGetCreateQuoteRateResults } from '@/modules/spot-quote/hooks/use-get-create-quote-rate-results';
import type { QuoteRateCriteria } from '@/modules/spot-quote/types';
import { useLocation, useParams } from 'react-router-dom';

interface LocationState {
  encodedRatesKey: string;
  quote: QuoteRateCriteria;
}

const RateShopResultsTab = () => {
  const location = useLocation();
  const { quoteKey } = useParams();
  const encodedRatesKey = (location?.state as LocationState)?.encodedRatesKey;
  const { data: rateResults = [], isLoading } = quoteKey
    ? useGetQuoteRates(quoteKey)
    : useGetCreateQuoteRateResults(encodedRatesKey);

  return (
    <div className="h-100 custom-scroll-bar">
      <QuoteRateResults isLoading={isLoading} quoteRates={rateResults} />
    </div>
  );
};

export default RateShopResultsTab;
